export default "/images/moscov.png?1ee08c5d0bc5151e88c7f6af6981c01f";